import { useBrandFeatureCheck } from '@/brand';
import { useExperimentStatus } from '@/flags/use-experiments';

export const useIsBookingManagementLinksSupported = () => {
  const bookingManagementLinksFlagStatus = useExperimentStatus(
    'booking-management-links'
  );
  const bookingManagementBrandFeatureStatus =
    useBrandFeatureCheck('bookingManagement');

  return (
    bookingManagementLinksFlagStatus && bookingManagementBrandFeatureStatus
  );
};
